import * as React from "react";
import { getPaymentImplementation, getPaymentMethodSettings } from "../../../../Payments/modules/PaymentMethodsList/Payments/providers.js";
import { useAdyen } from "../../../../../../context/Adyen/context/Adyen/context.js";
const usePaymentMethodForm = (handleGpayCtaClick, onAuthorize) => {
  const { config } = useAdyen();
  const [selectedPaymentDetails, setSelectedPaymentDetails] = React.useState();
  const handlePaymentDataChange = React.useCallback(
    (paymentData, isValid) => {
      setSelectedPaymentDetails({
        data: paymentData,
        isValid
      });
    },
    []
  );
  const resetPaymentDetails = React.useCallback(() => {
    setSelectedPaymentDetails(void 0);
  }, []);
  const renderPaymentForm = React.useCallback(
    (selectedPaymentMethod) => {
      if (!selectedPaymentMethod) {
        return null;
      }
      const implementation = getPaymentImplementation(
        selectedPaymentMethod.provider,
        selectedPaymentMethod.type
      );
      const settings = getPaymentMethodSettings(
        selectedPaymentMethod.provider,
        selectedPaymentMethod.type,
        config
      );
      if (!implementation || !implementation.form) {
        return null;
      }
      return React.createElement(implementation.form, {
        onChange: handlePaymentDataChange,
        onClick: handleGpayCtaClick,
        onAuthorize,
        config: selectedPaymentMethod.config,
        settings
      });
    },
    [config, handleGpayCtaClick, handlePaymentDataChange, onAuthorize]
  );
  return React.useMemo(
    () => [renderPaymentForm, selectedPaymentDetails, resetPaymentDetails],
    [renderPaymentForm, selectedPaymentDetails, resetPaymentDetails]
  );
};
export {
  usePaymentMethodForm
};
//# sourceMappingURL=use-payment-method-form.js.map
